import { LitElement, html, css } from 'lit';
import { BootstrapCSS } from '../../resources/css/bootstrap.css';
import { EplibStyles } from '../../resources/css/style.css.js';

export class EplibHistoryView extends LitElement {

  static get styles() {
    return [
      BootstrapCSS,
      EplibStyles
    ];
  }

  async firstUpdated() {
    super.firstUpdated();
    document.title = 'EarlyPrint Library Application Release History';
    document.querySelector("meta[name='description']").setAttribute('content', 'History of changes to the EarlyPrint Library software');
  }

  render() {
    return html`
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="wrapper transparent">
            <div class="page-header">
              <h1>Library Application Release History</h1>
            </div>
            <div class="container-fluid">
              <div class="row">
                <div>
                  <p>
                    Version 1.31.0. October 2, 2026.
                  </p>
                  <ul>
                    <li>Implemented client-side routing and replaced all uses of eXist-db templating</li>
                    <li>Gave initial capitals a bit of a style boost</li>
                    <li>Dependency updates</li>
                  </ul>

                  <p>
                    Version 1.30.8. Septemer 13, 2026.
                  </p>
                  <ul>
                    <li>Replaced remaining eXist templates with web components (except for wrapper page)</li>
                    <li>Changes to login/logout to avoid page reload</li>
                    <li>Adjustments to improve what gets noticed by web crawlers</li>
                    <li>Fixed display of @orig attributes in annotation pane</li>
                    <li>Dependency updates</li>
                  </ul>
                  <p>
                    Version 1.30.7. June 28, 2026.
                  </p>
                  <ul>
                    <li>Added better metadata to HTML head</li>
                    <li>Switched to BlackLab for title/metadata retrieval</li>
                    <li>Added sitemap index and sitemaps to help search engines</li>
                    <li>Dependency updates</li>
                  </ul>

                  <p>
                    Version 1.30.6. June 9, 2026.
                  </p>
                  <ul>
                    <li>Consolidated handling of fonts and icons</li>
                    <li>Converted stylesheets to web-component-friendly imports</li>
                    <li>Fixed bugs in page navigation buttons</li>
                    <li>Consolidated animation for all components that do page navigation</li>
                    <li>Dependency updates</li>
                  </ul>

                  <p>
                    Version 1.30.5. May 25, 2026.
                  </p>
                  <ul>
                    <li>Migrated text browsing to a custom web component</li>
                    <li>Removed a lot of unused code</li>
                    <li>Minor dependency updates</li>
                  </ul>

                  <p>
                    Version 1.30.4. April 25, 2026.
                  </p>
                  <ul>
                    <li>Improved page navigation animation</li>
                    <li>Improved space handling in KWIC results</li>
                    <li>Made option choices persist across sessions</li>
                    <li>Minor bug fixes and routine dependency updates</li>
                  </ul>
                  <p>
                    Version 1.30.3. October 10, 2025.
                  </p>
                  <ul>
                    <li>Removed some obsolete dependencies</li>
                    <li>Bug fixes to enabling/disabling annotations</li>
                    <li>Fix selections for join in Safari</li>
                  </ul>
                  <p>
                    Version 1.30.2. October 4, 2025.
                  </p>
                  <ul>
                    <li>Migrate content handling to custom web component</li>
                    <li>Minor bug fixes and routine dependency updates</li>
                  </ul>
                  <p>
                    Version 1.30.1. September 17, 2025.
                  </p>
                  <ul>
                    <li>Migrate facsimile handling to custom web component</li>
                    <li>Minor bug fixes and routine dependency updates</li>
                  </ul>
                  <p>
                    Version 1.30.0. June 19, 2025.
                  </p>
                  <ul>
                    <li>Migrate annotation components from Polymer to Lit</li>
                    <li>Routine dependency updates</li>
                  </ul>

                  <p>
                    Version 1.29.9. March 28, 2025.
                  </p>
                  <ul>
                    <li>Make image retrieval failure messages more legible</li>
                    <li>Replace search form, text filter form, review filter form, table of contents, and action bar with web components</li>
                    <li>Make action bar option choices persist for the duration of the session</li>
                    <li>Numerous small bug fixes and enhancements</li>
                    <li>Routine dependency updates</li>
                  </ul>

                  <p>
                    Version 1.29.8. July 6, 2024.
                  </p>
                  <ul>
                    <li>Re-implemented Review page to use BlackLab for contexts</li>
                    <li>Allow annotation client to work with documents in shadow DOM</li>
                    <li>Allow annotation panel to grow vertically</li>
                    <li>Routine dependency updates</li>
                  </ul>
                  <p>
                    Version 1.29.7. June 2, 2024.
                  </p>
                  <ul>
                    <li>Added word count rubrics</li>
                    <li>Upgraded dependencies, notably OpenSeadragon, tei-publisher-lib, and annotation client.</li>
                    <li>Reimplemented registration form, converting from Polymer to Lit</li>
                    <li>Removed all direct dependencies on Polymer</li>
                    <li>Switched to new NU-hosted BlackLab server for search</li>
                  </ul>
                  <p>
                    Version 1.29.6. September 23, 2023.
                  </p>
                  <ul>
                    <li>New login form component</li>
                    <li>Miscellaneous code clean-up</li>
                  </ul>
                  <p>
                    Version 1.29.5. September 1, 2023.
                  </p>
                  <ul>
                    <li>Routine dependency updates</li>
                    <li>Fixed whitespace handling in HTML downloads</li>
                    <li>Now preserve space in CQL searches</li>
                    <li>Better handling of errors from BlackLab search</li>
                    <li>Added stripped XML as a download option</li>
                    <li>Reimplemented page slider as a web component</li>
                    <li>Fixed broken enable/disable annotations option</li>
                    <li>Annotations are now off by default for touch screens</li>
                  </ul>
                  <p>
                    Version 1.29.4. February 19, 2023.
                  </p>
                  <ul>
                    <li>Routine dependency updates</li>
                    <li>Layout improvements for large screens</li>
                    <li>Minor bug fixes and code clean-up</li>
                    <li>Documentation updates and additions</li>
                  </ul>
                  <p>
                    Version 1.29.3. September 17, 2022.
                  </p>
                  <ul>
                    <li>Documentation updates to reflect inclusion of Evans and ECCO</li>
                    <li>Hide EEBO link when no EEBO images available</li>
                    <li>Minor dependency updates and documentation fixes</li>
                    <li>Remove MOBI download links -- ePub can now be e-mailed to Kindles</li>
                  </ul>
                  <p>
                    Version 1.29.2. May 28, 2022.
                  </p>
                  <ul>
                    <li>Replace eXist-based search with BlackLab search</li>
                    <li>N.B. Search in coordination with the text filter is temporarily unavailable.</li>
                  </ul>
                  <p>
                    Version 1.29.1. May 9, 2022.
                  </p>
                  <ul>
                    <li>Navigation improvements for BlackLab results</li>
                    <li>Upgraded OpenSeadragon IIIF viewer</li>
                    <li>Clean-up of unused code</li>
                  </ul>
                  <p>
                    Version 1.29.0. April 30, 2022.
                  </p>
                  <ul>
                    <li>Upgrade to Boostrap 5</li>
                  </ul>
                  <p>
                    Version 1.28.3. April 1, 2022.
                  </p>
                  <ul>
                    <li>Further refinements and fixes to experimental BlackLab search page</li>
                    <li>Handle footnotes and marginal notes for display purposes</li>
                  </ul>
                  <p>
                    Version 1.28.2. February 13, 2022.
                  </p>
                  <ul>
                    <li>Refinements to experimental BlackLab search page</li>
                  </ul>
                  <p>
                    Version 1.28.1. December 4, 2021.
                  </p>
                  <ul>
                    <li>Move EEBO link to top toolbar</li>
                    <li>Upgrade to eXist 5.3.0</li>
                    <li>Add experimental BlackLab search page</li>
                  </ul>
                  <p>
                    Version 1.27.2. November 29, 2020.
                  </p>
                  <ul>
                    <li>Fix bug where note references made entire paragraphs superscript</li>
                    <li>Landing page navigation and content updates</li>
                    <li>Build EEBO links with new Proquest GOID rather than VID</li>
                    <li>Switch to externally-generated e-book downloads</li>
                    <li>Add MOBI as a download format for people with Kindles</li>
                  </ul>
                  <p>
                    Version 1.27.1. August 16, 2020.
                  </p>
                  <ul>
                    <li>Faster page turning by avoiding the annotation service when fetching XML fragments</li>
                  </ul>
                  <p>
                    Version 1.27.0. August 14, 2020.
                  </p>
                  <ul>
                    <li>Polymer 3 upgrade for annotation features as well as login and registration pages</li>
                  </ul>
                  <p>
                    Version 1.26.1. June 12, 2020.
                  </p>
                  <ul>
                    <li>Prevent search without text filter</li>
                    <li>Condense speaker/speech display</li>
                    <li>Miscellaneous layout and display changes</li>
                  </ul>
                  <p>
                    Version 1.26.0. November 2, 2019.
                  </p>
                  <ul>
                    <li>Redo style to match the rest of earlyprint.org</li>
                  </ul>
                  <p>
                    Version 1.25.8. October 24, 2019.
                  </p>
                  <ul>
                    <li>Upgrade multiple Javascript libraries to patch vulnerabilities</li>
                    <li>Yet another login page workaround</li>
                    <li>Preparations for eXist 5.0</li>
                  </ul>
                  <p>
                    Version 1.25.7. July 20, 2019.
                  </p>
                  <ul>
                      <li>Added a faster sorting mechanism for the browse page</li>
                      <li>Consolidated some options under the options menu</li>
                      <li>Added a link to the EEBO page image where possible</li>
                      <li>Made text selectable (and thus copyable) when annotations are disabled</li>
                      <li>Moved from unmaintained tei-simple library to tei-publisher-lib</li>
                  </ul>
                  <p>
                    Version 1.25.6. December 2, 2018.
                  </p>
                  <ul>
                      <li>New capability to review annotations in context</li>
                      <li>Revised login page with better error messages</li>
                  </ul>
                  <p>
                    Version 1.25.5. July 21, 2018.
                  </p>
                  <ul>
                    <li>Use friendly URLs based on EEBO page identifiers</li>
                    <li>Use publication year in metadata when creation year is unavailable</li>
                    <li>Miscellaneous internal bug fixes and code clean-up</li>
                    <li>More robust metadata generation for the More button</li>
                    <li>More PDF and ePub fixes</li>
                    <li>Add facsimile screenshot capability</li>
                  </ul>
                  <p>
                    Version 1.25.4. April 28, 2018.
                  </p>
                  <ul>
                    <li>Temporary patches for login problems</li>
                    <li>Add gap search feature courtesy of Doug Knox</li>
                    <li>Fix space handling and preserve highlighting of search results</li>
                    <li>Leave space between line groups (e.g., stanzas) and other style improvements</li>
                    <li>Add Evans as a corpus choice</li>
                    <li>Speed up table of contents generation, especially for large texts</li>
                    <li>Remove extraneous "mark" tagging when annotating a highlighted search result</li>
                    <li>Other bug fixes and performance improvements</li>
                  </ul>
                  <p>
                    Version 1.25.3. March 16, 2018.
                  </p>
                  <ul>
                    <li>Rewrite ePub and PDF exports in XSL for performance</li>
                    <li>Make download links honor standard/orginal spelling choice</li>
                    <li>Add close button to annotation panel</li>
                    <li>Include schema processing instruction in downloaded XML files for easier validation</li>
                    <li>Avoid link behavior in references that seldom have links</li>
                    <li>Allow sorting of the works list</li>
                    <li>Filter and sort by word and work counts and include them under More button</li>
                    <li>Include witness note indicating page image source under More button</li>
                  </ul>
                  <p>
                    Version 1.25.2. December 15, 2017.
                  </p>
                  <ul>
                    <li>Stay on current page when logging in</li>
                    <li>Better navigation after searching or logging in</li>
                  </ul>
                  <p>
                    Version 1.25.1. November 25, 2017.
                  </p>
                  <ul>
                    <li>New browse filter allowing multiple criteria at once</li>
                    <li>Update versions pf Bootstrap, PolymerJS, and OpenSeaDragon</li>
                    <li>Fix display of textual notes and cast list</li>
                    <li>Documentation updates</li>
                    <li>Fix role retrieval bug</li>
                    <li>Improve speed of ePub generation</li>
                    <li>Better accommodate fast paging</li>
                  </ul>
                  <p>
                    Version 1.25.0. September 28, 2017.
                  </p>
                  <ul>
                    <li>New logo and color scheme for EarlyPrint branding</li>
                    <li>Documentation updates</li>
                    <li>Bug fixes and custom style for page slider</li>
                    <li>Bug fixes to PDF generation</li>
                  </ul>
                  <p>
                    Version 1.24.12. August 26, 2017.
                  </p>
                  <ul>
                    <li>Add a page navigation slider</li>
                    <li>Truncate very long titles</li>
                    <li>Display image attributions when we have them</li>
                  </ul>
                  <p>
                    Version 1.24.11. June 24, 2017.
                  </p>
                  <ul>
                    <li>Improvement to logo presentation in footer</li>
                    <li>Changes to 'More' button in browse view</li>
                    <li>Internal rearrangement of texts and annotations to handle larger numbers of texts</li>
                  </ul>
                  <p>
                    Version 1.24.10. May 30, 2017.
                  </p>
                  <ul>
                    <li>New method to handle whitespace behind the scenes (no 'c' elements)</li>
                  </ul>
                  <p>
                    Version 1.24.9. May 6, 2017.
                  </p>
                  <ul>
                    <li>New method to toggle modern/original spellings</li>
                    <li>Annotation client changes to handle regular spellings as attributes</li>
                    <li>Fix PDF generation.</li>
                    <li>More layout and design tweaks</li>
                  </ul>
                  <p>
                    Version 1.24.8. April 8, 2017.
                  </p>
                  <ul>
                    <li>Slim down browse view to make more texts visible at once</li>
                    <li>Add more logos to the bottom bar</li>
                    <li>Make text and image panes the same height and make the text pane scrollable</li>
                    <li>Put morphology fields on annotation panel into a collapsible expander</li>
                  </ul>
                  <p>
                    Version 1.24.7. March 15, 2017.
                  </p>
                  <ul>
                    <li>First public beta of the new shc.earlyprint.org site</li>
                    <li>Numerous documentation updates</li>
                    <li>Assorted bug fixes and interface tweaks</li>
                    <li>Annotation panel is now draggable</li>
                  </ul>
                  <p>
                    Version 1.24.3. January 16, 2017.
                  </p>
                  <ul>
                    <li>Includes new annotation module from eXist Solutions GmbH</li>
                  </ul>
                  <p>
                    Version 0.3. June 24, 2016.
                  </p>
                  <ul>
                    <li>Simplify the word IDs.</li>
                    <li>Correct some of the morphological adornments.</li>
                  </ul>
                  <p>
                    Version 0.2. May 1, 2016.
                  </p>
                  <ul>
                    <li>Enable access to XML versions of texts.</li>
                    <li>Generate epubs from texts.</li>
                    <li>Fix filtering by grade letters.</li>
                    <li>Enhance text search facility.</li>
                  </ul>
                  <p>
                    Version 0.1. April 11, 2016.
                  </p>
                  <ul>
                    <li>Initial prerelease of web site.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  }
}

customElements.define('eplib-history-view', EplibHistoryView);